<main class="main main-with-bg" role="main" id="main" tabindex="-1">

    <!-- CONNEXION -->
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="text-center">
                    <h1>{{ "connexion.title" | translate }}</h1>
                    <p class="fz-16">
                        {{ "connexion.lead" | translate }}
                        <br />
                        <br />
                        {{ "connexion.enSavoirPlus" | translate }}
                        <a [href]="CONNECTION_ABOUT_URL" class="external-link" target="_blank">{{ "connexion.cliquezIci" | translate }}</a>{{ "." }}
                    </p>
                </div>
            </div>

            <div class="col-md-10 col-lg-10">
                <div class="group-col mt-4">
                    <div class="group-col__item">
                        <p class="mb-0 fz-16">{{ "connexion.subtitle" | translate }}</p>
                        <div *ngIf="!isCookiesAccepted" class="group-col__item">
                            <div class="o-alert o-alert--info">
                                <div class="o-alert__icon">
                                    <svg class="svg-icon svg-circle-info" aria-hidden="true" focusable="false"><use xlink:href="svg-icons/icon-sprite.svg#circle-info"></use></svg>
                                </div>
                                {{ 'connexion.cookiesMessagePart1' | translate }} <a class="default-link" (click)="showCookiesPopin()">{{ 'connexion.cookiesMessagePart2' | translate }} </a>
                            </div>
                        </div>
                        <div *ngIf="isCookiesAccepted" class="group-col__item">
                            <!-- Il désactive le bouton et le sur clic si les cookies n'ont pas été acceptés -->
                            <button #pscButton *ngIf=" !loadingLogin" class="my-4" (click)="load()">
                                <a rel="noreferrer noopener">
                                    <img src="assets/img/icons-illustratives/ProSanteConnect_sidentifier_COULEURS.svg"
                                        width="280" height="54" alt="Se connecter via PRO SANTÉ CONNECT" />
                                </a>
                            </button>
                            <app-loader></app-loader>
                        </div>

                        <div class="d-flex flex-column flex-md-row justify-content-around fz-16">
                            <a [href]="CONNECTION_HELP_ECPS_URL" class="btn--icon-before external-link text-center mb-2"
                                target="_blank">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false">
                                    <use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use>
                                </svg>
                                {{ "connexion.aideECPS" | translate }}
                            </a>
                            <a [href]="CONNECTION_HELP_CART_URL" class="btn--icon-before external-link text-center mb-2"
                                target="_blank">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false">
                                    <use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use>
                                </svg>
                                {{ "connexion.aideCarte" | translate }}
                            </a>
                        </div>

                        <app-message></app-message>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- BANNER MESSAGES -->
    <div *ngIf="bannerMessages?.length > 0" class="region region-content mt-5">
        <div class="paragraph-space paragraph--flash-info bg-gray-800 text-white">
            <div class="container">
                <div class="paragraph--flash-info__teasers">
                    <div class="tns-outer" id="tns3-ow">
                        <div id="tns3-mw" class="tns-ovh">
                            <div class="tns-inner" id="tns3-iw">
                                <div class="paragraph--flash-info__slider  tns-slider tns-carousel tns-subpixel tns-calc tns-horizontal" id="tns3" style="transition-duration: 0s; transform: translateX(0%);">
                                    <article *ngFor="let item of bannerMessages; index as i" class="m-flash-info tns-item tns-slide-active" id="tns3-item{{i}}">
                                        <div class="m-flash-info__content">
                                            <h2 class="m-flash-info__title fw-medium">
                                                <a
                                                    *ngIf="item?.href"
                                                    class="external-link"
                                                    target="_blank"
                                                    [href]="item?.href"
                                                    [title]="item?.title">
                                                    {{ item.text }}
                                                </a>

                                                <span *ngIf="!item?.href">{{ item.text }}</span>
                                            </h2>

                                            <p
                                                class="m-flash-info__tag subtitle rounded bottom-left-radius-0 mb-1"
                                                [ngClass]="
                                                    (item.category === bannerMessageType.INFO_FLASH) ? 'bg-brand-2' :
                                                    (item.category === bannerMessageType.A_LA_UNE) ? 'bg-white' :
                                                    (item.category === bannerMessageType.DECRYPTAGE) ? 'bg-white' : 'bg-primary'">
                                                {{ item.category }}
                                            </p>
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</main>
<div *ngIf="!this.isCookiesAccepted">
    <app-cookies #cookiesComponent (cookiesAcceptedEvent)="onCookiesAccepted($event)"></app-cookies>
</div>
